import React, { useEffect, useState, createRef } from 'react'
import Ubi from '../../utils/ubi.js'

const Preview = props => {
  const [isLoad, setIsLoad] = useState({
    ubihtml: false,
    ubimsg: false,
    ubinonax: false,
    allLoad: false
  });

    
  useEffect(() => {
    async function getUbihtml(){
      if (!document.getElementById('ubihtml')) {
        const scriptUbihtml = document.createElement('script');
        scriptUbihtml.id = 'ubihtml';
        scriptUbihtml.src = '/js/ubi/ubihtml.js';
        scriptUbihtml.onload = () => isLoading('ubihtml');
        document.body.appendChild(scriptUbihtml);
      } else {
        isLoading('ubihtml');
      }
    }
    getUbihtml();
    
    if (!document.getElementById('ubimsg')) {
      const scriptUbiMsg = document.createElement('script');
      scriptUbiMsg.id = 'ubimsg';
      scriptUbiMsg.src = '/js/ubi/msg.js';
      scriptUbiMsg.onload = () => isLoading('ubimsg');
      document.body.appendChild(scriptUbiMsg);
    } else {
      isLoading('ubimsg');
    }
    
    if (!document.getElementById('ubinonax')) {
      const scriptUbiNonax = document.createElement('script');
      scriptUbiNonax.id = 'ubinonax';
      scriptUbiNonax.src = '/js/ubi/ubinonax.js';
      scriptUbiNonax.onload = () => isLoading('ubinonax');
      document.body.appendChild(scriptUbiNonax);
    } else {
      isLoading('ubinonax');
    }
  }, []);

  useEffect(() => {
    UbiLoadReport();
  }, [isLoad.allLoad]);
    
  const isLoading = ((target) => {
    if(!isLoad[target]){
      isLoad[target] = true;
      isLoad.allLoad = isLoad.ubihtml && isLoad.ubimsg && isLoad.ubinonax;
    }
    //if(isLoad.allLoad) setIsLoad(Object.assign({}, isLoad));
  });
  
  const UbiLoadReport = async () => {
    if(!isLoad.allLoad) {
      setTimeout(() => {UbiLoadReport();}, 1000);
      return;
    }
    
    // 기존에 생성된 컴포넌트 초기화
    let ubiHTMLViewer = document.getElementById('UbiHTMLViewer');
    
    var app = '';
    //var appUrl = self.location.protocol + '//' + self.location.host + (app==''?'':('/' + app));
    var appUrl = `${process.env.REACT_APP_API_HOST}ubi`;

    /* Viewer Object */
    let htmlViewer = null;
    
    /* Viewer Param */
    var pKey = new Date() * 1;
    var pServerUrl = appUrl +'/UbiServer';
    var pResUrl = appUrl + '/ubi4/js/';
    var pResId = 'EZP';
    var pDivId = 'UbiHTMLViewer';
    var pScale = 'PageWidth';	//WholePage/PageWidth/60~300
    //var pJrf = 'global_apodoc_10008.jrf'; 
    var pJrf = props.jrffile; 
    
    //var pArg = '';    
    //var ds = 'ds_info#"^t성상현^tsoptimist@agencypro.co.kr^t2021.04.21"#';
    //var pFile = 'aaaa';
    var pArg = props.arg;
    var ds = await Ubi.convDs(props.ds, props.layoutCd);
    var pFile = props.filename;

    ubiHTMLViewer.innerHTML = '';
    ubiHTMLViewer.style.width = '100%';
    ubiHTMLViewer.style.height = '600px';
    htmlViewer = new document.UbiViewer( {
        key : pKey,
        ubiserverurl : pServerUrl,
        resource : pResUrl,
        resid : pResId,
        divid : pDivId,
        scale : pScale,
        jrffile : pJrf,
        streamdata : ds,
        arg : pArg,
        reporttitle : pFile,
        exportAsOrgImage: true,
        // issvg : true,
        imagescale : '300'
    });

    htmlViewer.setVisibleToolbar("SAVE_EXCEL",false);
    htmlViewer.setVisibleToolbar("SAVE_DOCX",false);
    htmlViewer.setVisibleToolbar("SAVE_HML",false);
    htmlViewer.setVisibleToolbar("SAVE_PPTX",false);
    htmlViewer.setVisibleToolbar("SAVE_CELL",false);
    htmlViewer.setVisibleToolbar("SAVE_IMAGE",false);
    htmlViewer.setVisibleToolbar("PRINT_UBI",false);
    htmlViewer.setVisibleToolbar("PRINT_HTML",false);
    
    htmlViewer.showReport(() => {
      console.log('preview end');
    });

    htmlViewer.events.exportEnd = (flag, msg) => {
      console.log(flag, msg);
    };

    htmlViewer.events.printEnd = (flag) => {
      console.log(flag);
    };
  }

  return (
    <>
      <div id='UbiHTMLViewer'></div>
    </>
    
  )
}

export default Preview
